import { HttpClient, provideHttpClient } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppInitService } from './app-init.service';
import { appRoutes } from './app.routes';
import { CommunityInfoService } from './services/community-info.service';
import { DefaultInfoService } from './services/default-info.service';
import { FisherImageService } from './services/fisher-image.service';
import { MarketapiProvider } from './services/marketplace.service';
import { SpeciesInfoService } from './services/species-info.service';

function initializeApp(appInitService: AppInitService) {
    return async () => {
        await appInitService.init();
    };
}


export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes),
        provideHttpClient(),
        provideTranslateService({
            loader: provideTranslateHttpLoader({ prefix: 'assets/i18n/', suffix: '.json' })
        }),
        MarketapiProvider,
        SpeciesInfoService,
        DefaultInfoService,
        CommunityInfoService,
        FisherImageService,
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [AppInitService],
            multi: true
        }
    ]
};
